<template>
  <div class="solution">
    <umf-header style="position: absolute;"></umf-header>
    <div class="banner">
      <div class="row">
        <h4>
          <img src="~images/solution/banner-text.png"
               alt="">
        </h4>
        <p>鑫毅数科数字化行业解决方案， </p>
        <p>以技术创新服务金融和实体产业，</p>
        <p>助力各行业数字转型、智能升级、融合创新。</p>
      </div>
    </div>
    <div class="page-one">
      <div class="row">
        <h3>方案简介</h3>
        <div class="center-bg">
          <div class="text-box">
            <h4>银行数据中台解决方案</h4>
            <p>鑫毅数科结合大数据、人工智能等技术对中小银行数据进行综合治理，为其构建数据采集、分析、治理、开发、调度、可视化分析、建模等全流程工具，驱动中小银行数据“数字化”，帮助中小银行在强监管和智能服务时代，打造统一的数据共享服务中心，改变其营销、获客前端业务流程，驱动其风控、运营中后台变革，帮助中小银行完成数字化转型、智能化转型。</p>
          </div>
        </div>
      </div>
    </div>

    <div class="page-two">
      <div class="row">
        <h3>方案优势</h3>
        <div class="center-box">
          <div class="ulList">
            <div class="ulListBox">
              <div class="left">
                <img src="~images/solution/icon1.png" alt="">
                <p>微服务容器化部署 </p>
              </div>
              <div class="right">
                <img src="~images/solution/icon2.png" alt="">
                <p>产品模块灵活组合，快速响应业务需求</p>
              </div>
            </div>
            
            <div class="ulListBox">
              <div class="left">
                <img src="~images/solution/icon3.png" alt="">
                <p>多终端、多业务多形态的全域数据接入</p>
              </div>
              <div class="right">
                <img src="~images/solution/icon2.png" alt="">
                <p>降低建设门槛，提升建设效率 降低数据</p>
              </div>
            </div>

            <div class="ulListBox">
              <div class="left">
                <img src="~images/solution/icon3.png" alt="">
                <p>降低数据开发成本、降低数据使用成本 </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <umf-footer  :topBanner='1'></umf-footer>
  </div>
</template>

<script>
import UmfHeader from '@/components/umfHeader'
import umfFooter from '@/components/umfFooter'
import vueSeamlessScroll from 'vue-seamless-scroll'
import $ from 'jquery'
export default {
  components: {
    UmfHeader,
    umfFooter
  },

  computed: {

  },
  data () {
    return {


    }
  },

  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/solution/solution.scss";
.ulList {
  width: 1200px;
  .ulListBox {
    width: 1200px;
    height: 40px;
    background: #efeff3;
    border: 1px solid #e1e2e6;
    padding: 20px 50px;
    .left {
      width: 600px;
      height: 40px;
      display: inline-block;
      img {
        float: left;
      }
      p {
        float: left;
        line-height: 40px;
        color: #515259;
        font-size: 18px;
        padding-left: 45px;
      }
    }
    .right {
      width: 50%;
      height: 40px;
      display: inline-block;
      img {
        float: left;
      }
      p {
        float: left;
        line-height: 40px;
        color: #515259;
        font-size: 18px;
        padding-left: 45px;
      }
    }
  }
}
</style>

